export default "__VITE_ASSET__Bm3X1uaB__"